import api from '@/apis/di/payrollItemAPI.js';
import Crud from '@/stores/crudBase';
var crud = new Crud('payrollItem', api);

const state = {
  ...crud.state,
  _config: {
    table: 'di_payroll_item',
    field: {
      key: 'payroll_item_id',
      code: 'payroll_item_code',
      name: 'payroll_item_name',
      quickFollow: 'inactive',
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
